import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ChildFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M14.9007 12.1389L14.8472 12.0855C14.249 11.5085 13.4477 11.5085 11.984 11.5085C10.5203 11.5085 9.69767 11.5085 9.12075 12.0855C8.52246 12.6517 8.52246 13.4316 8.52246 14.8419V15.8889C8.52246 16.6154 8.52246 17.1068 8.90708 17.4701C9.14212 17.6944 9.43058 17.8013 9.90067 17.8226H9.97545V20.0556C9.97545 20.7821 9.97545 21.2735 10.3601 21.6368C10.7447 22 11.2468 22 12.0054 22C12.7639 22 13.266 22 13.64 21.6368C14.0246 21.2735 14.0246 20.7821 14.0246 20.0556V17.8333H14.0994C14.516 17.8013 14.8152 17.7372 15.093 17.4701C15.4776 17.1068 15.4776 16.6154 15.4776 15.8889V14.8419C15.4776 13.4637 15.4776 12.6944 14.9327 12.1282L14.9007 12.1389Z"
				fill="currentColor"
			/>
			<path
				d="M11.984 10.8889C13.0951 10.8889 14.0032 10.0128 14.0032 8.93376C14.0032 7.8547 13.0951 7 11.984 7C10.8729 7 9.96478 7.86538 9.96478 8.93376C9.96478 10.0021 10.8729 10.8782 11.984 10.8889Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ChildFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ChildFilledIcon;
